import { Camera, Loader2 } from 'lucide-react';

const ChartCaptureButton = ({ 
  onCapture, 
  isCapturing = false,
  className = "" 
}) => {
  return (
    <button
      onClick={onCapture}
      disabled={isCapturing}
      className={`p-1.5 sm:p-2 hover:bg-gray-700 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      aria-label="Capture chart screenshot"
    >
      {isCapturing ? (
        <Loader2 className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white animate-spin" />
      ) : (
        <Camera className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white" />
      )}
    </button>
  );
};

export default ChartCaptureButton;